import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: '../views/dashboard.component.html',
    styleUrls: ['../css/dashboard.component.css'],
    providers: [GlobalDataService]
})
export class DashboardComponent implements OnInit {

    public leadNew: number = 0;
    public leadPending: number = 0;
    public casesOpenInquiries: number = 0;
    public casesOpenConcerns: number = 0;
    public userid: string;

    constructor(private _dataService: GlobalDataService) {}

    ngOnInit() {

        //this.userid = localStorage.getItem('userId')
        this.userid = sessionStorage.getItem('userId');
        //        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^"+sessionStorage.getItem('user'))

        this.getLeadsCount();
        this.getCaseCount();
    }
    /**
     * @author Nagendra
     * @param userid
     * @returns lead count(new,pending)
     */
    getLeadsCount() {
        this._dataService.getLeadSummary(this.userid, (result) => {
            result.forEach(eachObj => {
                if (eachObj.key == "Lead.New") {this.leadNew = eachObj.value}
                if (eachObj.key == "Lead.Open") {this.leadNew += eachObj.value;}
                if (eachObj.key == "Lead.Pending") {this.leadPending = eachObj.value}
            });
        });

    }
    /**
     * @author Nagendra
     * @param userid
     * @returns Case count(Inquiries,Concerns)
     */
    getCaseCount() {
        this._dataService.getCaseSummary(this.userid, (result) => {
            result.forEach(eachObj => {
                if (eachObj.key == "Case.inquiry") {this.casesOpenInquiries = eachObj.value}
                if (eachObj.key == "Case.concern") {this.casesOpenConcerns = eachObj.value}
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/dashboard.component.ts